import { interceptorMiddleware } from '../../../shared/services/interceptor.service';
import { createApi } from '@reduxjs/toolkit/query/react';
import { apiUrlPaymentPlan } from '../constants/apiUrl.paymentPlan';
import {
    ApiParamEnum,
    HttpMethods,
} from '../../../shared/constants/application.constant';
import { ListResponse } from '../../../shared/utils/types.elements';
import { PaymentPlan } from '../constants/types';
import { ConstNumber } from '../../../shared/constants/number.constant';
import { getDataRequest, getUpdatedValues } from '../utils/subscriptionsUtils';

// Define a service using a base URL and expected endpoints
export const paymentPlanApi = createApi({
    reducerPath: 'paymentPlan',
    baseQuery: interceptorMiddleware,
    tagTypes: ['paymentPlan'],
    endpoints: (builder) => ({
        createPaymentPlan: builder.mutation({
            query: (data: any) => {
                const payload = getDataRequest(data);
                return {
                    url: apiUrlPaymentPlan.PAYMENT_PLAN,
                    method: HttpMethods.POST,
                    body: payload,
                };
            },
        }),
        getPaymentPlans: builder.query<
            ListResponse<PaymentPlan>,
            { page: number; planType: number }
        >({
            query: ({ page, planType }) => ({
                url: `${apiUrlPaymentPlan.PAYMENT_PLAN}?limit=${
                    ApiParamEnum.LIMIT
                }&offset=${
                    (page - ConstNumber.VALUE_1) * ApiParamEnum.OFFSET
                }&plan_type=${planType}`,
                method: HttpMethods.GET,
            }),
            providesTags: ['paymentPlan'],
        }),
        getPaymentPlanById: builder.query<PaymentPlan, number>({
            query: (id: number) => ({
                url: `${apiUrlPaymentPlan.PAYMENT_PLAN}${id}/details/`,
                method: HttpMethods.GET,
            }),
            providesTags: ['paymentPlan'],
            keepUnusedDataFor: ConstNumber.VALUE_1,
        }),
        updatePaymentPlan: builder.mutation<
            {
                message: string;
            },
            { data: any; initialValues: any }
        >({
            query: ({ data, initialValues }) => {
                const dataRequest = getDataRequest(data);
                const changedValues = getUpdatedValues(
                    initialValues,
                    dataRequest
                );
                return {
                    url: `${apiUrlPaymentPlan.PAYMENT_PLAN}${data.id}/`,
                    method: HttpMethods.PATCH,
                    body: changedValues,
                };
            },
        }),
        deActivatePaymentPlan: builder.mutation<
            {
                message: string;
            },
            { id?: number; data: any }
        >({
            query: ({ id, data }) => {
                return {
                    url: `${apiUrlPaymentPlan.PAYMENT_PLAN}${id}/`,
                    method: HttpMethods.PATCH,
                    body: data,
                };
            },
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useCreatePaymentPlanMutation,
    useGetPaymentPlansQuery,
    useGetPaymentPlanByIdQuery,
    useUpdatePaymentPlanMutation,
    useDeActivatePaymentPlanMutation,
} = paymentPlanApi;
